import { TaskEvent } from '@dispatch/shared/types';

export const mockTimelineComplete: TaskEvent[] = [
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'assignment-created',
    eventDateTime: new Date('2022-12-14T16:00:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'adjuster-assigned',
    eventDateTime: new Date('2022-12-14T16:00:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
    adjusterId: 'adjusterId_1',
    adjusterName: 'adjuster name',
    adjusterPhone: '+1888888888',
    adjusterEmail: 'adjuster_email',
    adjusterLocation: {
      street: 'street',
      city: 'city',
      state: 'state',
      zip: '12345',
    },
    adjusterExternalId: '13f88b42-9b5f-11ed-a8fc-0242ac120002',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'adjuster-reassigned',
    eventDateTime: new Date('2022-12-14T16:00:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
    adjusterId: 'adjusterId_2',
    adjusterName: 'reassigned adjuster name',
    adjusterPhone: '+1888888888',
    adjusterEmail: 'reassigned adjuster_email',
    adjusterLocation: {
      street: 'street',
      city: 'city',
      state: 'state',
      zip: '12345',
    },
    adjusterExternalId: '13f88b42-9b5f-11ed-a8fc-0242ac120002',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'assignment-rescheduled',
    eventDateTime: new Date('2022-12-16T22:00:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'assignment-locked',
    eventDateTime: new Date('2022-12-19T00:00:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'assignment-unlocked',
    eventDateTime: new Date('2022-12-19T03:00:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'assignment-locked',
    eventDateTime: new Date('2022-12-19T05:00:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'adjuster-started-inspection',
    eventDateTime: new Date('2022-12-20T16:45:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'adjuster-completed-inspection',
    eventDateTime: new Date('2022-12-20T17:15:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
];

export const mockTimelineCancel: TaskEvent[] = [
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'assignment-created',
    eventDateTime: new Date('2022-12-16T14:34:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'adjuster-assigned',
    eventDateTime: new Date('2022-12-16T14:34:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
    adjusterId: 'adjusterId_1',
    adjusterName: 'adjuster name',
    adjusterPhone: '+1888888888',
    adjusterEmail: 'adjuster_email',
    adjusterLocation: {
      street: 'street',
      city: 'city',
      state: 'state',
      zip: '12345',
    },
    adjusterExternalId: '13f88b42-9b5f-11ed-a8fc-0242ac120002',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'assignment-cancelled',
    eventDateTime: new Date('2022-12-18T21:36:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
  {
    tenantId: 'tenantId',
    subscriberId: 'subscriberId',
    eventId: 'eventId',
    eventCode: 'adjuster-removed',
    eventDateTime: new Date('2022-12-16T22:00:00+00:00').toISOString(),
    createdBy: 'createdBy',
    assignmentId: 'assignmentId',
    claimNumber: 'claimNumber',
  },
];
